module.exports = __webpack_public_path__ + "static/media/Electric_hum.a312849e.mp3";